import { render, staticRenderFns } from "./StudentQueryList.vue?vue&type=template&id=a61c4f04&scoped=true&"
import script from "./StudentQueryList.vue?vue&type=script&lang=ts&"
export * from "./StudentQueryList.vue?vue&type=script&lang=ts&"
import style0 from "./StudentQueryList.vue?vue&type=style&index=0&id=a61c4f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c4f04",
  null
  
)

export default component.exports